import { render, staticRenderFns } from "./CandidateComments.vue?vue&type=template&id=84810412&scoped=true"
import script from "./CandidateComments.vue?vue&type=script&lang=js"
export * from "./CandidateComments.vue?vue&type=script&lang=js"
import style0 from "./CandidateComments.vue?vue&type=style&index=0&id=84810412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84810412",
  null
  
)

export default component.exports